// @ts-strict-ignore
import keyBy from 'lodash/keyBy';

import {MpEvent} from 'common/util/definitions-types';
import {topEventsClient} from 'common/report/queries/query-api/top-events-client';

import {Store} from './store';

interface Events {
  [eventName: string]: MpEvent;
}

export const topEventsStore = new Store<Events>({
  apiClient: topEventsClient,
  defaultValue: {},
  name: `top-events`,
  transform: {
    index: (response) => keyBy(response, `name`),
  },
});
